import { $ } from '@/Engine/state';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { onTempItems } from '@/Engine/eventHandlers/onTempItems';
import { useUIOnlyStore } from '@/Store/storeUI';
import { useStoreData } from '@/Store/storeData';


export const afterMoveHandler = () => {
    const configuratorStore = useConfigurationStore();
    const tempWindowIndex = $.windows.findIndex((window) => window.uuid === 'temp');

    if ($.windows[tempWindowIndex] && $.windows[tempWindowIndex].model.parent) {
        $.windows[tempWindowIndex].model.removeFromParent();
        $.windows.splice(tempWindowIndex, 1);
        if ($.tempWindowData)
            configuratorStore.addWindow($.tempWindowData);
        $.tempWindowData = null;
    }
    $.removeWindowsByUUID('temp');
    const tempDoorIndex = $.doors.findIndex((door) => door.uuid === 'temp');
    if ($.doors[tempDoorIndex] && $.doors[tempDoorIndex].model.parent) {
        $.doors[tempDoorIndex].model.removeFromParent();
        $.doors.splice(tempDoorIndex, 1);
        if ($.tempDoorData)
            configuratorStore.addDoor($.tempDoorData);
        $.tempDoorData = null;
    }
    $.removeDoorByUUID('temp');

    const tempBoxIndex = $.boxes.findIndex((box) => box.uuid === 'temp');
    if ($.boxes[tempBoxIndex] && $.boxes[tempBoxIndex].model.parent) {
        $.boxes[tempBoxIndex].model.removeFromParent();
        $.boxes.splice(tempBoxIndex, 1);
        if ($.tempBoxData)
            configuratorStore.addBox($.tempBoxData);
        $.tempBoxData = null;
    }
    $.removeBoxByUUID('temp');


    $.moved = false;
    $.dragging = false;
    $.bigDistanceFlag = false;
    $.ctrlKey =false;
    useUIOnlyStore().setElementInfoActive(true);
    if ($.selectionBox.target ||
        $.selectionBox.targetGroup.length ||
        $.updated ||
        $.selectionBoxForBox.target)
            onTempItems();

    useStoreData().resetDnDElement();
};
